import { styled } from '@mui/material/styles';

export const StyledSection = styled('div')`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-top: ${({ theme }) => theme.spacing(4)};
    padding-bottom: ${({ theme }) => theme.spacing(4)};
    padding-left: ${({ theme }) => theme.spacing(9)};
    padding-right: ${({ theme }) => theme.spacing(9)};
    max-width: 1640px;
  }
`;

export const StyledPaddedSection = styled(StyledSection)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-top: ${({ theme }) => theme.spacing(4)};
    padding-bottom: ${({ theme }) => theme.spacing(4)};
    padding-left: ${({ theme }) => theme.spacing(21)};
    padding-right: ${({ theme }) => theme.spacing(21)};
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: ${({ theme }) => theme.spacing(9)};
    padding-bottom: ${({ theme }) => theme.spacing(9)};
    padding-left: ${({ theme }) => theme.spacing(3)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`;
